import React from 'react';

function ContainerWithSidebar({ sidebar, main }) {
  return (
    <div className="container-with-sidebar">
      <div className="sidebar">
        {sidebar}
      </div>
      <div className="main-container">
        {main}
      </div>
    </div>
  );
}

export default ContainerWithSidebar;
